export default __webpack_public_path__ + "static/watch-2c93cfdf301d93beba5fbd07345b2fd6.png";